import React, { useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const CustomDatePicker = (props) => {
  const [date, setDate] = useState(null);
  const dateFormat = props.format || 'MM/dd/yyyy';

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        format={dateFormat}
        value={date}
        onChange={(newDate) => {
          setDate(newDate);
          props.onFilterChanged(props.columnDef.tableData.id, newDate);
        }}
        slotProps={{
          field: { clearable: true },
          textField: { size: 'small', variant: 'standard' },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
